var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundPattern(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 308,
    viewBox: "0 0 375 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_2391",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -52,
    y: -172,
    width: 480,
    height: 480
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 480,
    transform: "translate(-52 -172)",
    fill: "url(#paint0_radial_17_2391)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_2391)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_2391)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_17_2391)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: -172,
    x2: 12.5,
    y2: 308,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.5,
    y1: -172,
    x2: 44.5,
    y2: 308,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.5,
    y1: -172,
    x2: 76.5,
    y2: 308,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.5,
    y1: -172,
    x2: 108.5,
    y2: 308,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.5,
    y1: -172,
    x2: 140.5,
    y2: 308,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.5,
    y1: -172,
    x2: 172.5,
    y2: 308,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.5,
    y1: -172,
    x2: 204.5,
    y2: 308,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.5,
    y1: -172,
    x2: 236.5,
    y2: 308,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.5,
    y1: -172,
    x2: 268.5,
    y2: 308,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.5,
    y1: -172,
    x2: 300.5,
    y2: 308,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 332.5,
    y1: -172,
    x2: 332.5,
    y2: 308,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364.5,
    y1: -172,
    x2: 364.5,
    y2: 308,
    stroke: "#E4E7EC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -51.5,
    y: -171.5,
    width: 479,
    height: 479,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_17_2391)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -52,
    y1: 19.5,
    x2: 428,
    y2: 19.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -52,
    y1: 51.5,
    x2: 428,
    y2: 51.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -52,
    y1: 83.5,
    x2: 428,
    y2: 83.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -52,
    y1: 115.5,
    x2: 428,
    y2: 115.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -52,
    y1: 147.5,
    x2: 428,
    y2: 147.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -52,
    y1: 179.5,
    x2: 428,
    y2: 179.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -52,
    y1: 211.5,
    x2: 428,
    y2: 211.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -52,
    y1: 243.5,
    x2: 428,
    y2: 243.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -52,
    y1: 275.5,
    x2: 428,
    y2: 275.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -52,
    y1: 307.5,
    x2: 428,
    y2: 307.5,
    stroke: "#E4E7EC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -51.5,
    y: -171.5,
    width: 479,
    height: 479,
    stroke: "#E4E7EC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_17_2391",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240 240) rotate(90) scale(240 240)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_2391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 480,
    fill: "white",
    transform: "translate(-52 -172)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_17_2391"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -52,
    y: -172,
    width: 480,
    height: 480,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_17_2391"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -52,
    y: -172,
    width: 480,
    height: 480,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundPattern);
export default __webpack_public_path__ + "static/media/Background_pattern.2d44d870f1a410426272e688c1660c25.svg";
export { ForwardRef as ReactComponent };